import { styled } from '@mui/material'

export const FeedbackContent = styled('div')({
  height: '100%', 
  display: 'flex', 
  flexDirection: 'column' 
});

export const FeedbackInfo = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%'
});

export const FeedbackText = styled('div')({
  paddingTop: '8px',
  fontSize: '14px',
  display: '-webkit-box',
  '-webkit-line-clamp': '2',
  '-webkit-box-orient': 'vertical',
  overflow: 'hidden'
});

export const Toolbar = styled('div')({
  padding: '20px',
  margin: 'auto 0 0 0',
  borderTop: 'solid 1px rgba(189, 195, 202, 1)',
});
